<template>
  <div @click="go(item.id)" :id="item.id" class="hov group cursor-pointer">
    <small>{{index + 1}}</small>
    <q-icon :name="$utils.icon(item.id)" />
    <unit-path :id="item.id" :withoutLink="true"></unit-path>
    <result-fields :item="item" @pass="go(item.id, $event)"></result-fields>
  </div>
</template>

<style scoped>

</style>

<script type="text/babel">
import UnitPath from './unit-path.vue';
import ResultFields from './result-fields.vue';

// var inViewport = require('in-viewport')
export default {
  components: {
    UnitPath,
    ResultFields,
  },
  props: ['item', 'index'],
  data() {
    return {};
  },
  computed: {},
  watch: {},
  methods: {
    go(id, event) {
      console.log('id, mediaId', id, event);
      if (event) {
        this.$router.push(`/found/${id}?mid=${event}`);
      } else {
        this.$router.push(`/found/${id}`);
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/result-item.vue